export default __webpack_public_path__ + "static/media/bicycle-online.17ae6cf7.png";